export class MdbBaryChartModel {
  constructor(public dataset: Array<any>, public labels: Array<string>) {}
}
